




















































































































































































































































































































































































import { Component, Provide, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import http from '@/http'
import _get from '@/helpers/_get'
import FundingRequestModel, {
  FundingRequestAttribute,
  FundingRequestBusinessModel,
} from '@/modules/funding-request/funding-request.model'
import FundingRequestFieldModel, {
  FundingRequestFieldAttribute,
  IFundingRequestItems,
} from '@/modules/funding-request-field/funding-request-field.model'
import IFundingRequestResponse from '@/modules/funding-request/funding-request-response.interface'
import IFundingRequestFieldResponse from '@/modules/funding-request-field/funding-request-field-response.interface'
import { FieldTypes } from '@/components/Form/FieldTypes'
import { AxiosError, AxiosResponse } from 'axios'
import { AdminRoutes } from '@/helpers/getRouteMeta'
import _ from 'lodash'
import permissions from '@/helpers/permissions'
import can from '@/helpers/can'
import { Getters } from '@/store/auth/getters'
import FormBase from '@/classes/Form/FormBase'
import UserModel, { UserAttribute } from '@/modules/user/user.model'
import Tabs from '@/components/Tabs.vue'
import ITabs from '@/interfaces/tabs'
import VerificationModel, { VerificationAttribute } from '@/modules/verification/verification.model'
import { FinancierAttribute } from '@/modules/financier/financier.model'
import { Actions } from '@/store/global/actions'
import { RoleAttribute } from '@/modules/role/role.model'
import $t from '@/helpers/translations'
import { fundingRequestItemsPrivate } from '@/modules/funding-request-field/funding-request-items-private'

@Component({
  components: {
    PageHeader,
    Tabs,
  },
  methods: {
    $t,
    _get,
    can,
  },
})
export default class Show extends Vue {
  user: UserModel = this.$store.getters[Getters.getUser]
  form!: FormBase
  permissions = permissions
  fundingRequest: FundingRequestModel | null = null
  fundingRequestFields: FundingRequestFieldModel[] | null = null
  fundingRequestItems: IFundingRequestItems[] = fundingRequestItemsPrivate
  listRoute: string = AdminRoutes.offersIndex
  archivedRouted: string = AdminRoutes.archivedFundingRequests
  jsonFields: FundingRequestFieldModel[] = []
  applicantDocument: IDocumentOption[] = []
  spouseDocument: IDocumentOption[] = []

  tabs: ITabs[] = [
    {
      to: AdminRoutes.fundingRequestsShowTabOffers,
      title: 'Pasiūlymai',
      permissions: [permissions.fundingRequests.offers],
    },
    {
      to: AdminRoutes.fundingRequestsShowTabDocuments,
      title: 'Papildomi dokumentai',
      permissions: [permissions.additionalDocuments.getDocuments],
    },
    {
      to: AdminRoutes.fundingRequestsShowTabAssignedUsers,
      title: 'Priskirti darbuotojai',
      permissions: [permissions.financiers.userFundingRequests],
    },
    {
      to: AdminRoutes.fundingRequestsShowTabActivityLog,
      title: 'Paraiškos veiksmų istorija',
      permissions: [permissions.activityLog.fundingRequest],
    },
    {
      to: AdminRoutes.fundingRequestsShowTabAssignedFinanciers,
      title: 'Paraiškos finansuotojai',
      permissions: [permissions.fundingRequests.getAssignedFinanciers],
    },
    {
      to: AdminRoutes.fundingRequestsShowTabVerifications,
      title: 'Tapatybės patvirtinimai',
      permissions: [permissions.verifications.index],
    },
    {
      to: AdminRoutes.fundingRequestsShowTabDsti,
      title: 'DSTI',
      permissions: [permissions.dsti.show],
    },
  ]
  steps: object = {
    steps_debts_complete: 'Skolos',
    steps_nasis_complete: 'NASIS Registras',
    steps_sodra_complete: 'Sodra',
    steps_wanted_person_complete: 'Paieškomų asmenų registras',
    spouse_steps_debts_complete: 'Sutuoktinio skolos',
    spouse_steps_nasis_complete: 'Sutuoktinio NASIS Registras',
    spouse_steps_sodra_complete: 'Sutuoktinio Sodra',
    spouse_steps_wanted_person_complete: 'Sutuoktinio paieškomų asmenų registras',
  }
  politics = {
    head_of_state:
      'Valstybės vadovas, vyriausybės vadovas, ministras, viceministras arba ministro pavaduotojas, valstybės sekretorius, parlamento, vyriausybės arba ministerijos kancleris',
    member_of_parliament: 'Parlamento narys',
    member_of_the_supreme_court:
      'Aukščiausiųjų teismų, konstitucinių teismų ar kitų aukščiausiųjų teisminių institucijų, kurių sprendimai negali būti skundžiami, narys',
    mayor_of_the_municipality: 'Savivaldybės meras, savivaldybės administracijos direktorius',
    member_of_the_board:
      'Aukščiausiosios valstybių audito ir kontrolės institucijos valdymo organo narys ar centrinio banko valdybos pirmininkas, jo pavaduotojas ar valdybos narys',
    ambassador:
      'Ambasadorius, laikinasis reikalų patikėtinis, nepaprastasis pasiuntinys ir įgaliotasis ministras ar aukšto rango ginkluotųjų pajėgų karininkas',
    member_of_a_state_owned_enterprise:
      'Valstybės įmonės, akcinės bendrovės, uždarosios akcinės bendrovės, kurių akcijos ar dalis akcijų, suteikiančių daugiau kaip 1/2 visų balsų šių bendrovių visuotiniame akcininkų susirinkime, priklauso valstybei nuosavybės teise, valdymo ar priežiūros organo narys',
    member_of_a_municipal_enterprise:
      'Savivaldybės įmonės, akcinės bendrovės, uždarosios akcinės bendrovės, kurių akcijos ar dalis akcijų, suteikiančių daugiau kaip 1/2 visų balsų šių bendrovių visuotiniame akcininkų susirinkime, priklauso savivaldybei nuosavybės teise ir kurios laikomos didelėmis įmonėmis pagal Lietuvos Respublikos įmonių finansinės atskaitomybės įstatymą, valdymo ar priežiūros organo narys',
    head_of_an_international_intergovernmental_organization:
      'Tarptautinės tarpvyriausybinės organizacijos vadovas, jo pavaduotojas, valdymo ar priežiūros organo narys',
  }

  @Provide('fundingRequest') getFundingRequest(): FundingRequestBusinessModel | null {
    return this.fundingRequest
  }

  async created(): Promise<void> {
    await this.loadFundingRequest()

    if (this.$route.name === AdminRoutes.fundingRequestsShow) {
      this.listRoute = AdminRoutes.fundingRequestsIndex
    }

    if (
      this.$route.name !== AdminRoutes.fundingRequestsShowTabDocuments &&
      this.$route.name !== AdminRoutes.fundingRequestsShowTabOffers &&
      this.$route.name !== AdminRoutes.fundingRequestsShowTabActivityLog &&
      this.$route.name !== AdminRoutes.businessFundingRequestsShowTabActivityLog
    ) {
      const firstTab = document.querySelector<HTMLAnchorElement>('#extraTabs a')

      if (firstTab) {
        firstTab.click()
      }
    }
  }

  get recommendedDocuments(): any[] {
    return _.filter(this.fundingRequest?.attachments, (item: any) => ['funding_request'].includes(item.group))
  }

  get hasSpouse(): boolean {
    return this.fundingRequest?.data.is_married && !this.fundingRequest?.data.for_personal_needs
  }

  get additionalDocuments(): any[] {
    const documentTypes: string[] = [
      'work_certificate',
      'bank_statement',
      'bank_statement_lt',
      'income_and_expenses_documents',
      'income_declaration',
      'business_certificate',
      'work_contract',
      'customer_contract',
      'current_loans',
    ]

    return _.filter(this.fundingRequest?.attachments, (item: any) => documentTypes.includes(item.group))
  }

  get additionalRealEstateDocuments(): any[] {
    const documentTypes: string[] = ['real_estate_documents', 'real_estate_rating', 'pictures']

    return _.filter(this.fundingRequest?.attachments, (item: any) => documentTypes.includes(item.group))
  }

  get additionalSpouseDocuments(): any[] {
    const documentTypes: string[] = [
      'spouse_work_certificate',
      'spouse_bank_statement',
      'spouse_income_and_expenses_documents',
      'spouse_income_declaration',
      'spouse_business_certificate',
      'spouse_work_contract',
      'spouse_customer_contract',
      'spouse_current_loans',
    ]

    return _.filter(this.fundingRequest?.attachments, (item: any) => documentTypes.includes(item.group))
  }

  get getBankAccount(): string {
    if (this.fundingRequest && this.fundingRequest[FundingRequestAttribute.verifications]) {
      const innerData = this.fundingRequest.data

      const verification: VerificationModel = this.fundingRequest[FundingRequestAttribute.verifications].find(
        (el) => el.personcode === parseInt(innerData.personcode, 10),
      )

      return verification && verification[VerificationAttribute.account]
        ? verification[VerificationAttribute.account]
        : '-'
    }

    return '-'
  }

  goToList(): void {
    if (this.forbidChanges) {
      this.$router.push({ name: this.archivedRouted })

      return
    }
    this.$router.push({ name: this.listRoute })
  }

  get forbidChanges(): boolean {
    return !this.user[UserAttribute.isAdmin] && !!this.fundingRequest?.archived_at
  }

  get hasAbilityToViewBankAccount(): boolean {
    if (this.user[UserAttribute.isAdmin]) {
      return true
    }

    return (
      this.user[UserAttribute.financier] && this.user[UserAttribute.financier][FinancierAttribute.requiredBankAccount]
    )
  }

  isSignedDocument(itemGroup): boolean {
    return ['user-signed-documents', 'old-user-signed-documents'].includes(itemGroup)
  }

  fundingIsNotRealEstate(fundingType: string): boolean {
    return fundingType !== 'individual_loan_with_real_estate_exchange' && fundingType !== 'individual_home_loan'
  }

  hasSignedDocuments(): any {
    if (this.fundingRequest?.offers) {
      const signedDocuments: any = []

      this.fundingRequest?.offers.forEach((item: any) => {
        if (
          item.user_signed_documents.find((documentItem) =>
            ['user-signed-documents', 'old-user-signed-documents'].includes(documentItem.group),
          )
        ) {
          signedDocuments.push(item)
        }
      })

      return signedDocuments.length > 0
    }

    return false
  }

  editFundingRequest(): void {
    this.$router.push({ name: AdminRoutes.fundingRequestsEdit })
  }

  loadFundingRequest(): void {
    http
      .get(`/funding-requests/${this.$router.currentRoute.params.uuid}`)
      .then(
        (
          response: AxiosResponse<{
            funding_request: IFundingRequestResponse
            funding_request_fields: IFundingRequestFieldResponse[]
          }>,
        ) => {
          this.fundingRequestFields = response.data.funding_request_fields.map((item: IFundingRequestFieldResponse) =>
            new FundingRequestFieldModel().transform(item),
          )
          this.fundingRequest = new FundingRequestModel().transform(response.data.funding_request)
          this.applicantDocument.push({
            label: 'Dokumento tipas',
            value: this.noInfoToString(
              this.documentTypeToString(response.data.funding_request.data_field?.dsti?.documentType),
            ),
          })
          this.applicantDocument.push({
            label: 'Dokumento numeris',
            value: this.noInfoToString(response.data.funding_request.data_field?.dsti?.documentNumber),
          })
          this.applicantDocument.push({
            label: 'Dokumento galiojimo pabaiga',
            value: this.noInfoToString(response.data.funding_request.data_field?.dsti?.documentExpiry),
          })

          if (this.fundingRequest.data && this.fundingRequest.data.is_married) {
            this.spouseDocument.push({
              label: 'Dokumento tipas',
              value: this.noInfoToString(
                this.documentTypeToString(response.data.funding_request.data_field?.dsti?.spouse?.documentType),
              ),
            })
            this.spouseDocument.push({
              label: 'Dokumento numeris',
              value: this.noInfoToString(response.data.funding_request.data_field?.dsti?.spouse?.documentNumber),
            })
            this.spouseDocument.push({
              label: 'Dokumento galiojimo pabaiga',
              value: this.noInfoToString(response.data.funding_request.data_field?.dsti?.spouse?.documentExpiry),
            })
          }

          this.fundingRequestItems.forEach((itemBlock: IFundingRequestItems) => {
            itemBlock.items.forEach((item: any) => {
              item.value = this.getValue(this.fundingRequest?.data, item)
            })
          })
        },
      )
      .finally(this.filterJsonFields)
  }

  noInfoToString(fieldValue: any): any {
    if (!fieldValue && fieldValue !== 0) {
      return 'Nėra informacijos'
    }

    return fieldValue
  }

  filterJsonFields(): void {
    this.fundingRequestItems.forEach((itemBlock: IFundingRequestItems) => {
      itemBlock.items.forEach((item: any) => {
        if (item.type === 'json') {
          const conditionalKey = item.show_if

          if (!conditionalKey || _.get(this.fundingRequest?.data, conditionalKey)) {
            this.jsonFields.push(item)
          }
        }
      })
    })
  }

  getOptionValue(optionvalue, option): string {
    const key = optionvalue[option.value]

    const opt = option.options.filter((o) => o.value === key)

    return opt.length ? opt[0].label : ''
  }

  isFieldVisibleByRole(field: FundingRequestFieldModel): boolean {
    if (field[FundingRequestFieldAttribute.visibleByRoleSlug] === null) {
      return true
    }

    return field[FundingRequestFieldAttribute.visibleByRoleSlug]!.includes(
      this.user[UserAttribute.role][RoleAttribute.slug],
    )
  }

  documentTypeToString(documentType: any): any {
    if (documentType === 'I') return 'Asmens tapatybės kortelė'

    if (documentType === 'P') return 'Pasas'

    return documentType
  }

  downloadLoanDocument(): void {
    if (this.fundingRequest && this.fundingRequest.uuid) {
      http(`funding-requests/${this.fundingRequest.uuid}/get-signed-document`, {
        responseType: 'blob',
        method: 'GET',
      })
        .then(async (response) => {
          const fileName = response.headers['content-disposition'].split('filename=')[1]

          const blobUrl = URL.createObjectURL(response.data)

          const link = document.createElement('a')

          link.setAttribute('href', blobUrl)
          link.setAttribute('download', fileName)
          link.click()
        })
        .catch(async (error: AxiosError) => {
          if (error.response) {
            await this.$store.dispatch(Actions.showSnackbar, {
              type: 'error',
              message: error.response.data.message,
            })
          }
        })
    }
  }

  downloadPersonReport(): void {
    if (this.fundingRequest && this.fundingRequest.uuid) {
      http(`funding-requests/${this.fundingRequest.uuid}/get-person-report`, {
        responseType: 'blob',
        method: 'GET',
      })
        .then(async (response) => {
          const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/['"]+/g, '')

          const blobUrl = URL.createObjectURL(response.data)

          const link = document.createElement('a')

          link.setAttribute('href', blobUrl)
          link.setAttribute('download', fileName)
          link.click()
        })
        .catch(async (error: AxiosError) => {
          if (error.response) {
            await this.$store.dispatch(Actions.showSnackbar, {
              type: 'error',
              message: error.response.data.message,
            })
          }
        })
    }
  }

  downloadSpouseReport(): void {
    if (this.fundingRequest && this.fundingRequest.uuid) {
      http(`funding-requests/${this.fundingRequest.uuid}/get-spouse-report`, {
        responseType: 'blob',
        method: 'GET',
      })
        .then(async (response) => {
          const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/['"]+/g, '')

          const blobUrl = URL.createObjectURL(response.data)

          const link = document.createElement('a')

          link.setAttribute('href', blobUrl)
          link.setAttribute('download', fileName)
          link.click()
        })
        .catch(async (error: AxiosError) => {
          if (error.response) {
            await this.$store.dispatch(Actions.showSnackbar, {
              type: 'error',
              message: error.response.data.message,
            })
          }
        })
    }
  }

  getValue(data: object, field: FundingRequestFieldModel): string | false {
    if (field[FundingRequestFieldAttribute.key] === 'referral') {
      return this.fundingRequest?.referral || false
    }

    if (field[FundingRequestFieldAttribute.key] === 'bankAccount') {
      if (!this.hasAbilityToViewBankAccount) {
        return false
      }

      return this.getBankAccount || '-'
    }

    if (field[FundingRequestFieldAttribute.key] === 'address') {
      const address = this.fundingRequest?.data?.dsti?.address || false

      if (!address) {
        field[FundingRequestFieldAttribute.show] = false
      }

      return address
    }

    if (
      field[FundingRequestFieldAttribute.key] === 'spouse_have_financial_liabilities' ||
      field[FundingRequestFieldAttribute.key] === 'spouse_financial_liabilities'
    ) {
      if (!_.get(data, 'is_married')) {
        return false
      }
    }

    if (field.type === 'json') {
      field[FundingRequestFieldAttribute.show] = false

      return false
    }

    if (field.type === FieldTypes.select) {
      const found = field.options.find((option: any) => option.value === _.get(data, field.key))

      return found ? found.label : _.get(data, field.key, (field[FundingRequestFieldAttribute.show] = false))
    }

    if (field.type === FieldTypes.checkbox) {
      return _.get(data, field.key) ? 'Taip' : 'Ne'
    }

    if (
      (field.key === 'email' ||
        field.key === 'phone' ||
        field.key === 'spouse_email' ||
        field.key === 'spouse_phone') &&
      this.fundingRequest &&
      !this.fundingRequest.hasDynamicPermissions([permissions.fundingRequests.complete]) &&
      !this.user[UserAttribute.isAdmin]
    ) {
      return '*******'
    }

    if (field.type === FieldTypes.number) {
      const amount = _.get(data, field.key, null)

      if (amount === null) {
        field[FundingRequestFieldAttribute.show] = false

        return false
      }

      return amount
    }

    const otherValue = _.get(data, field.key)

    if (!otherValue) {
      field[FundingRequestFieldAttribute.show] = false

      return false
    }

    return otherValue
  }

  isRefinancing(): boolean {
    return this.fundingRequest?.funding_type?.key === 'individual_refinancing'
  }

  get hasPoliticallyImportantPerson(): boolean {
    const politicalPerson = this.fundingRequest?.data?.politically_important_person

    return !!Object.keys(politicalPerson).length && politicalPerson.political_person_name !== ''
  }
}

interface IDocumentOption {
  label: string
  value: string
}
